import type { LoginViewTranslation } from './loginView.translation.pl.ts';

export const loginViewTranslation: LoginViewTranslation = {
  title: 'Click to continue',
  loading: 'Logging in...',
  buttons: {
    start: "Let's start!",
    continue: 'Continue',
    login: 'Log in',
  },
  toast: {
    loginError: 'Login error',
    unknownError: 'An unexpected error occurred. Please try again.',
  },
  welcomeFirst: {
    title: 'Hi! Great to have you here.',
    message: "Let's not waste any time. Let's start the recruitment game.",
  },
  welcomeAdmin: {
    title: 'Welcome!',
    message: 'Log in as an administrator.',
  },
  welcomeAgain: {
    title: 'Great to see you here again.',
    message:
      "I was starting to think I'd lost touch with you. Let's not waste any time. You can continue the recruitment game.",
  },
};
